import { useState } from 'react';
import {
    FormControl,
    FormLabel,
    Stack,
    Box,
    FormErrorMessage,
} from '@chakra-ui/react';
import { Field } from 'formik';
import NameField from '@/components/forms/new/formikFormFields/NameField';
import TriggerFieldToolTip from './TriggerFieldToolTip';
import { useTriggerForm } from '../useTriggerForm.js';
import { FORM_FIELD_PATHS } from '../triggerFormConstants.js';
import walkthroughIds from '../../walkthroughIds';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

// Custom Formik field component for NameField
const NameFieldWrapper = ({
    field,
    form,
    darkMode,
    setCursorPosition,
    formData,
    updateFormData,
    editMode,
    ...props
}) => {
    const handleChange = (e) => {
        const newValue = e.target.value;

        // Update context with the new value
        updateFormData(FORM_FIELD_PATHS.URI, newValue);

        // Also update Formik field value for validation
        form.setFieldValue(field.name, newValue);

        // Update cursor position if function is provided
        if (setCursorPosition) {
            setCursorPosition(e.target.selectionStart || 0);
        }
    };

    const handleClick = (e) => {
        if (setCursorPosition) {
            setCursorPosition(e.target.selectionStart || 0);
        }
    };

    const currentValue = formData?.action?.uri || field.value || '';

    return (
        <NameField
            {...props}
            id="uri"
            name={field.name}
            value={currentValue}
            onChange={handleChange}
            onClick={handleClick}
            onBlur={() => {
                form.setFieldTouched(field.name, true);
            }}
            walkthroughid={editMode.ufUriInput}
            placeholder="https://example.com/webhook"
            darkMode={darkMode}
        />
    );
};

const WebhookUriInput = ({ darkMode, setCursorPosition, errors, touched }) => {
    const { editMode } = walkthroughIds;
    const [isHovered, setIsHovered] = useState(false);

    // Use context instead of Redux
    const { formData, updateFormData } = useTriggerForm();

    return (
        <FormControl
            sx={{ margin: '0 !important', position: 'relative' }}
            isInvalid={!!errors?.uri && touched?.uri}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <Box>
                    <FormLabel htmlFor="uri" sx={formLabelStyling(darkMode)}>
                        URI
                    </FormLabel>
                </Box>
                <Box flex={1} paddingTop="15px" maxWidth="400px">
                    <Field
                        component={NameFieldWrapper}
                        name="uri"
                        darkMode={darkMode}
                        setCursorPosition={setCursorPosition}
                        formData={formData}
                        updateFormData={updateFormData}
                        editMode={editMode}
                    />
                    {errors?.uri && touched?.uri && (
                        <FormErrorMessage>{errors.uri}</FormErrorMessage>
                    )}
                </Box>
                <TriggerFieldToolTip
                    isVisible={isHovered}
                    label="Enter the full URL where the webhook will be sent. Include protocol (https://) and any required query parameters."
                    ariaLabel="webhook-uri-tip"
                />
            </Stack>
        </FormControl>
    );
};

export default WebhookUriInput;
